module.exports = __webpack_public_path__ + "static/media/logo-header.36079bfd.jpg";